import { render } from "./ProfileAvatarComponent.vue?vue&type=template&id=29b293d4&ts=true"
import script from "./ProfileAvatarComponent.vue?vue&type=script&lang=ts"
export * from "./ProfileAvatarComponent.vue?vue&type=script&lang=ts"

import "./ProfileAvatarComponent.vue?vue&type=style&index=0&id=29b293d4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__